// AUTOGENERATED - MANUALLY CHANGES WILL BE REVERTED BY THE GENERATOR
// IUmbrella https://etherscan.io/address/0xD400fc38ED4732893174325693a63C30ee3881a8
export const UMBRELLA = '0xD400fc38ED4732893174325693a63C30ee3881a8';

// https://etherscan.io/address/0x929e21D24D3f2A529621AdC248D227012B72646d
export const UMBRELLA_IMPL = '0x929e21D24D3f2A529621AdC248D227012B72646d';

// https://etherscan.io/address/0x75e8aC0c063B6966E2A9954adEdf39BdE9370197
export const UMBRELLA_STAKE_TOKEN_IMPL = '0x75e8aC0c063B6966E2A9954adEdf39BdE9370197';

// https://etherscan.io/address/0x4655Ce3D625a63d30bA704087E52B4C31E38188B
export const UMBRELLA_REWARDS_CONTROLLER = '0x4655Ce3D625a63d30bA704087E52B4C31E38188B';

// https://etherscan.io/address/0x85C3371044e49782DbE3dC23de1D77a078aFb5d0
export const UMBRELLA_REWARDS_CONTROLLER_IMPL = '0x85C3371044e49782DbE3dC23de1D77a078aFb5d0';

// https://etherscan.io/address/0xF86F77F7531B3374274E3f725E0A81D60bC4bB67
export const PERMISSIONED_PAYLOADS_CONTROLLER = '0xF86F77F7531B3374274E3f725E0A81D60bC4bB67';

// https://etherscan.io/address/0x2759de67aD133C747C9f41d56F1b8A343cE679a1
export const PERMISSIONED_PAYLOADS_CONTROLLER_EXECUTOR =
  '0x2759de67aD133C747C9f41d56F1b8A343cE679a1';

// https://etherscan.io/address/0xCe6Ced23118EDEb23054E06118a702797b13fc2F
export const UMBRELLA_BATCH_HELPER = '0xCe6Ced23118EDEb23054E06118a702797b13fc2F';

// https://etherscan.io/address/0x3f3EfAeba02bbA78BA7E89Dc6Ec503C8fe5fd5a4
export const UMBRELLA_CONFIG_ENGINE = '0x3f3EfAeba02bbA78BA7E89Dc6Ec503C8fe5fd5a4';

// https://etherscan.io/address/0x5061c5aAEA55442a886fBC77dfD40e8489D1c07c
export const DATA_AGGREGATION_HELPER = '0x5061c5aAEA55442a886fBC77dfD40e8489D1c07c';

// https://etherscan.io/address/0x6c1DC85f2aE71C3DAcd6E44Bb57DEeF61b540a5A
export const DEFICIT_OFFSET_CLINIC_STEWARD = '0x6c1DC85f2aE71C3DAcd6E44Bb57DEeF61b540a5A';

export const CHAIN_ID = 1;
export const UMBRELLA_STAKE_ASSETS = {
  STK_WA_USDC_V1: {
    STAKE_TOKEN: '0x6bf183243FdD1e306ad2C4450BC7dcf6f0bf8Aa6',
    UNDERLYING: '0xD4fa2D31b7968E448877f69A96DE69f5de8cD23E',
    decimals: 6,
  },
  STK_WA_USDT_V1: {
    STAKE_TOKEN: '0xA484Ab92fe32B143AEE7019fC1502b1dAA522D31',
    UNDERLYING: '0x7Bc3485026Ac48b6cf9BaF0A377477Fff5703Af8',
    decimals: 6,
  },
  STK_WA_WETH_V1: {
    STAKE_TOKEN: '0xaAFD07D53A7365D3e9fb6F3a3B09EC19676B73Ce',
    UNDERLYING: '0x0bfc9d54Fc184518A81162F8fB99c2eACa081202',
    decimals: 18,
  },
  STK_GHO_V1: {
    STAKE_TOKEN: '0x4f827A63755855cDf3e8f3bcD20265C833f15033',
    UNDERLYING: '0x40D16FC0246aD3160Ccc09B8D0D3A2cD28aE6C2f',
    decimals: 18,
  },
} as const;
